"use strict";

export function initInScope($scope) {
    $scope.find('.js-select-tab').on('change', function () {
        let id = $(this).val();

        $('[href="' + id + '"],[data-toggle=tab][data-target="' + id + '"]').tab('show');
    });
}